export {ProductDetail} from './productDetail'


// WEBPACK FOOTER //
// ./src/features/product/index.js